import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  addPackage,
  updatePackage,
  getPackageById,
} from "../../services/packageService";
import "./AddPackageLayer.css";

const AddPackagePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const [form, setForm] = useState({
    id: "",
    name: "",
    price: "",
    total_calls: "",
    validity_days: "",
    created_at: "",
  });

  /* ======================
     LOAD DATA FOR UPDATE
  ====================== */
  useEffect(() => {
    if (id) {
      fetchPackage(id);
    }
  }, [id]);

  const fetchPackage = async (pkgId) => {
    setLoading(true);
    const data = await getPackageById(pkgId);
    if (data) {
      setForm({
        id: data.id || "",
        name: data.name || "",
        price: data.price || "",
        total_calls: data.total_calls || "",
        validity_days: data.validity_days || "",
        created_at: data.created_at || "",
      });
    }
    setLoading(false);
  };

  /* ======================
     HANDLE INPUT
  ====================== */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /* ======================
     SUBMIT
  ====================== */
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      id: form.id,
      name: form.name,
      price: Number(form.price),
      total_calls: Number(form.total_calls),
      validity_days: Number(form.validity_days),
    };

    const success = id
      ? await updatePackage(payload)
      : await addPackage(payload);

    if (success) {
      navigate("/package-list");
    }
  };

  return (
    <div className="page-container">
      <div className="card">
        <h5 className="card-title">
          {id ? "Update Package" : "Add Package"}
        </h5>

        {loading ? (
          <p>Loading package...</p>
        ) : (
          <form className="form-grid" onSubmit={handleSubmit}>
            {/* Package Name */}
            <div className="form-group">
              <label>Package Name</label>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Enter package name"
                required
              />
            </div>

            {/* Price */}
            <div className="form-group">
              <label>Price</label>
              <input
                type="number"
                name="price"
                value={form.price}
                onChange={handleChange}
                placeholder="Enter price"
                required
              />
            </div>

            {/* Total Calls */}
            <div className="form-group">
              <label>Total Calls</label>
              <input
                type="number"
                name="total_calls"
                value={form.total_calls}
                onChange={handleChange}
                placeholder="Enter total calls"
                required
              />
            </div>

            {/* Validity */}
            <div className="form-group">
              <label>Validity (Days)</label>
              <input
                type="number"
                name="validity_days"
                value={form.validity_days}
                onChange={handleChange}
                placeholder="Enter validity days"
                required
              />
            </div>

            {/* Submit */}
            <button className="btn-primary" type="submit">
              {id ? "Update Package" : "Save Package"}
            </button>
          </form>
        )}

        {/* CREATED TIME */}
        {/* {id && form.created_at && (
          <div className="update-time">
            <strong>Created At:</strong> {form.created_at}
          </div>
        )} */}
      </div>
    </div>
  );
};

export default AddPackagePage;
